import { RouteConfig } from 'vue-router'
import { prospectingRoutes } from '../constants/agency/'
import { requireAuth } from '../auth'

const LocationProspect = () =>
  import(
    /* webpackChunkName: "accounts" */ '@/pmd/pages/agency/LocationProspect.vue'
  )

export const prospecting: RouteConfig[] = [
  {
    path: '/prospecting',
    name: prospectingRoutes.default,
    component: LocationProspect,
    beforeEnter: requireAuth,
    children: [
      {
        path: ':pathMatch(.*)*',
        name: prospectingRoutes.anyProspect,
        component: LocationProspect,
      },
    ],
  },
]
